// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--BEpBB8rkT8GFOzoV"};